import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useProgressiveImage } from '../../hooks';
import { IUploadFile } from '../../store/models/general-models';
import { InlineSpinner } from '../../components';
import {
  LoaderWrapper,
  StyledImage,
  StyledImageBackground,
} from './lazy-image.styled';

interface IProps {
  photo: IUploadFile;
  isIntersecting?: boolean;
}

export const LazyImage: FC<IProps> = observer(({ photo, isIntersecting }) => {
  const { src, loading, isTransitioning } = useProgressiveImage({
    fullImageSrc: photo.fileSrc,
    isIntersecting,
  });

  return (
    <>
      {loading && (
        <LoaderWrapper>
          <InlineSpinner />
        </LoaderWrapper>
      )}
      <StyledImageBackground
        src={src || photo.thumbnailSrc || ''}
        loading={'lazy'}
        decoding={'async'}
        isLoading={loading}
        isTransitioning={isTransitioning}
      />
      <StyledImage
        src={src || photo.thumbnailSrc || ''}
        loading={'lazy'}
        decoding={'async'}
        isLoading={loading}
        isTransitioning={isTransitioning}
      />
    </>
  );
});
